const namespace = 'courseLiveOnline';

export const LIVE_ONLINE_COURSE_INFO = "liveOnlineInfo";
export const DISPATH_LIVE_ONLINE_COURSE_INFO = `${namespace}/${LIVE_ONLINE_COURSE_INFO}`

// 切换章节
export const LIVE_ONLINE_SWITCH_SECTION = "switchSection";
export const DISPATCH_LIVE_ONLINE_SWITCH_SECTION = `${namespace}/${LIVE_ONLINE_SWITCH_SECTION}`;

// 收藏课程
export const LIVE_ONLINE_COLLECT_COURSE = "collectCourse";
export const DISPATCH_LIVE_ONLINE_COLLECT_COURSE = `${namespace}/${LIVE_ONLINE_COLLECT_COURSE}`;
